var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Administrar organización"),
      ]),
      _vm._v(" "),
      _c(
        "article",
        {
          staticClass:
            "is-flex is-justify-content-space-between is-align-items-start",
        },
        [
          _c("h1", { staticClass: "title is-1" }, [_vm._v("Usuarios")]),
          _vm._v(" "),
          _c(
            "b-dropdown",
            {
              attrs: { "aria-role": "list", position: "is-bottom-left" },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function () {
                    return [
                      _c("b-button", {
                        staticClass: "is-small mb-2",
                        attrs: { "icon-left": "fas fa-ellipsis-h" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  attrs: { "aria-role": "listitem" },
                  on: { click: _vm.showDialogNumberOfUsers },
                },
                [
                  _c("b-icon", { attrs: { icon: "fas fa-users" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Verificar cantidad de usuarios")]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS.ID,
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
              ])
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "aria-role": "listitem" },
                      on: { click: _vm.openModalCargaMasiva },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "fas fa-upload" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Carga masiva de usuarios")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      !_vm.fetchingQueryParameters
        ? _c("Filtros", {
            attrs: { roles: _vm.roles, areas: _vm.areas },
            on: { "update:queryChanged": _vm.handleFilters },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("table", { staticClass: "table is-fullwidth" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.loading
          ? _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  { staticClass: "has-text-centered", attrs: { colspan: "4" } },
                  [_c("loading-spin")],
                  1
                ),
              ]),
            ])
          : _c(
              "tbody",
              [
                _vm._l(_vm.usuarios, function (usuario) {
                  return _c(
                    "tr",
                    { key: usuario.id, attrs: { id: usuario.id } },
                    [
                      _c("td", [
                        usuario.acceso_habilitado
                          ? _c("i", { staticClass: "fas fa-user fa-fw" })
                          : _c("i", { staticClass: "fas fa-user-slash fa-fw" }),
                        _vm._v(
                          "\n          " +
                            _vm._s(usuario.apellido) +
                            ", " +
                            _vm._s(usuario.nombre) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(usuario.cuil))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "has-text-centered" },
                        [
                          _vm.hasRole([_vm.constants.STRINGS.ROLES.LYRIS.ID])
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "usuarioBackupCertificado",
                                      params: {
                                        idOrganization: _vm.idOrganization,
                                        idUser: usuario.id,
                                      },
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(usuario.keystore ? "Si" : "No"))]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(usuario.keystore ? "Si" : "No")),
                              ]),
                          _vm._v(" "),
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                label: "El certificado no está aprobado",
                                type: "is-warning",
                              },
                            },
                            [
                              usuario.keystore && !usuario.keystore_habilitado
                                ? _c("b-icon", {
                                    attrs: {
                                      type: "is-warning",
                                      pack: "fas",
                                      icon: "exclamation-triangle",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(usuario.email))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "field has-addons is-pulled-right" },
                          [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "button is-small",
                                    attrs: {
                                      to: {
                                        name: "usuarioInfo",
                                        params: {
                                          idOrganization: _vm.idOrganization,
                                          idUser: usuario.id,
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small" },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-fw fa-eye fa-lg",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "button is-small",
                                    attrs: {
                                      to: {
                                        name: "usuarioEditar",
                                        params: {
                                          idOrganization: _vm.idOrganization,
                                          idUser: usuario.id,
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-fw fa-edit fa-lg",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "control" }, [
                              !usuario.acceso_habilitado &&
                              _vm.hasRole([
                                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                                _vm.constants.STRINGS.ROLES.LYRIS.ID,
                              ])
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-small is-info is-outlined",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openModalRehabilitarUsuario(
                                            usuario
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(1, true)]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-small is-danger is-outlined",
                                      attrs: {
                                        disabled: !usuario.acceso_habilitado,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openModalBajaUsuario(
                                            usuario
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(2, true)]
                                  ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.usuarios.length == 0 ? _c("tr", [_vm._m(3)]) : _vm._e(),
              ],
              2
            ),
      ]),
      _vm._v(" "),
      _c("paginator", {
        ref: "paginator",
        attrs: { resource: _vm.url, loading: _vm.loading },
        on: {
          update: _vm.updateResource,
          "update:loading": function ($event) {
            _vm.loading = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("CUIL")]),
        _vm._v(" "),
        _c("th", { staticClass: "has-text-centered" }, [
          _c("i", { staticClass: "fas fa-cloud" }),
          _vm._v(" Cert."),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", { staticClass: "has-text-right", attrs: { width: "100" } }, [
          _vm._v("Acciones"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-fw fa-user-plus fa-lg" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-fw fa-user-minus fa-lg" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "has-text-centered", attrs: { colspan: "4" } },
      [
        _c("section", { staticClass: "section is-mono" }, [
          _c("span", { staticClass: "tag is-rounded is-medium" }, [
            _c("i", { staticClass: "fas fa-info fa-fw" }),
            _vm._v(" Sin usuarios para mostrar\n            "),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }